import { FC, ReactNode, ReactElement } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import { ReactComponent as TrashIcon } from '../../static/icons/ic_trash.svg';
import { ReactComponent as EditIcon } from '../../static/icons/ic_edit.svg';

interface TTableActions {
  onConfirm?: (() => void) | undefined
  onDelete?: (() => void) | undefined
  dynamicIcon?: ReactNode & ReactElement | null;
}

const TableActions: FC<TTableActions> = ({
  onConfirm,
  onDelete,
  dynamicIcon,
}) => {
  const actions: JSX.Element[] = [];

  if (dynamicIcon) {
    actions.push(
      <GridActionsCellItem
        key="dynamic"
        icon={dynamicIcon}
        label="View"
        onClick={onConfirm}
      />,
    );
  }

  if (onConfirm) {
    actions.push(
      <GridActionsCellItem
        id="edit-icon"
        key="confirm"
        icon={<SvgIcon fontSize="small" component={EditIcon} inheritViewBox />}
        label="Edit"
        onClick={onConfirm}
      />,
    );
  }

  if (onDelete) {
    actions.push(
      <GridActionsCellItem
        id="delete-icon"
        key="delete"
        icon={<SvgIcon fontSize="small" component={TrashIcon} inheritViewBox />}
        label="Delete"
        onClick={onDelete}
      />,
    );
  }

  return actions;
};

export { TableActions };
